
import { formatIndonesiaVehicleNo, formatMalaysiaVehicleNo, usesMalaysiaPlateRules, validateVehiclePlate } from "@/app/infrastructures/misc/common-library/ValidateVehiclePlate";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { CargoV2Controller } from "@/app/ui/controllers/CargoV2Controller";
import { Options, prop, Vue } from "vue-class-component";

class Props {
  modelValue = prop<string>({ default: "", type: String });
  isValid = prop<boolean>({ default: false, type: Boolean });
  marginVertical = prop<string>({ default: "my-1.5", type: String });
  isEdit = prop<boolean>({ default: false });
}

@Options({
  emits: ["update:modelValue", "update:isValid"]
})
class InputVehicleNo extends Vue.with(Props) {
  get accountCountry() {
    return AccountController.accountData.countryCode || "id";
  }

  get productCargo() {
    return CargoV2Controller.form.productCargo;
  }

  get value() {
    return this.modelValue;
  }

  set value(val: string) {
    this.$emit("update:modelValue", val);

    if (!val) {
      this.$emit("update:isValid", false);
    }
  }

  get usesMalaysiaPlateRules() {
    return usesMalaysiaPlateRules({
      countryCode: this.accountCountry,
      cargoProductCode: this.productCargo
    })
  }

  formatVehicleNo(value: string) {
    if (this.usesMalaysiaPlateRules) return formatMalaysiaVehicleNo(value);
    return formatIndonesiaVehicleNo(value);
  }
  get isValidVehicleNo(): boolean {
    const valid = validateVehiclePlate(this.value, {
      countryCode: this.accountCountry,
      cargoProductCode: this.productCargo
    })

    this.$emit("update:isValid", valid);
    return valid;
  }
  get isErrorVehicleNo(): boolean {
    return Boolean(this.value && !this.isValidVehicleNo);
  }
  get errorVehicleNo() {
    return this.isErrorVehicleNo
      ? this.$t("cargoV2.components.inputVehicleNo.invalidFormat")
      : "";
  }
}

export default InputVehicleNo;
